export default "__VITE_ASSET__BM9PCH2K__"